import ScrollingContainer from './ScrollingContainer'

export default ScrollingContainer
